module.exports = __webpack_public_path__ + "img/pic_50jifen3.c5950cb6.png";